<template>
  <div class="space-y-2">
    <div class="text-brand-soft text-2xl font-bold">
      <slot />
    </div>
    <div class="bg-brand-grey-light h-px w-15" />
  </div>
</template>
